import { classNames } from '~/utils/classNames';

interface ProgressBarProps {
  value: number;
  color: string;
  bgColor: string;
  height?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ProgressBar({ value, height, className, color, bgColor }: ProgressBarProps) {
  const heightClass = height === 'lg' ? 'h-3' : height === 'sm' ? 'h-1' : 'h-2';

  return (
    <div className={classNames('w-full rounded-full', heightClass, bgColor, className)}>
      <div
        className={classNames('rounded-full transition-[width]', heightClass, color)}
        style={{ width: `${value}%` }}
      ></div>
    </div>
  );
}
